// src/screens/Merchant/MerchantReviews.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './MerchantReviews.css'; // ✅ new custom styles

import backIcon from '../../assets/backspace-icon.png';
import placeholderPic from '../../assets/placeholder-logo.png';

function MerchantReviews({ user }) {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {


const fetchReviews = async () => {
  try {
    console.log('🔍 Fetching reviews for merchant:', user.username);
    const res = await api.get(`/reviews/by-merchant/${user.username}`);
    console.log('✅ Reviews received:', res.data);
    setReviews(res.data || []);
  } catch (err) {
    console.error('❌ Failed to fetch reviews:', err);
  } finally {
    setLoading(false);
  }
};


    if (user?.username) fetchReviews();
  }, [user]);

  const renderStars = (rating) => '⭐'.repeat(rating);

  return (
    <div className="merchant-dashboard-container">
      <div className="merchant-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="merchant-back-icon"
          onClick={() => navigate('/merchant/dashboard')}
        />
        <h2>Product Reviews</h2>
      </div>

      <div className="merchant-dashboard-scroll">
        {loading ? (
          <p style={{ padding: 20 }}>Loading reviews...</p>
        ) : reviews.length === 0 ? (
          <p style={{ padding: 20 }}>No reviews yet.</p>
        ) : (
          <div className="merchant-tiles-grid">
            {reviews.map((review, i) => (
              <div
                key={i}
                className="merchant-tile"
                onClick={() => navigate(`/product/${review.productId}`)}
              >
                <div className="merchant-icon">
                  <img
                    src={review.productMedia?.[0] || placeholderPic}
                    alt="product"
                    style={{ width: 40, height: 40, borderRadius: 8 }}
                  />
                </div>
                <div className="merchant-label" style={{ textAlign: 'left' }}>
                  <div><strong>{review.productName}</strong></div>
                  <div>{renderStars(review.rating)} — by @{review.username}</div>
                  <div style={{ fontSize: 12, marginTop: 4 }}>
                    “{review.text.length > 60 ? review.text.slice(0, 60) + '…' : review.text}”
                  </div>
                  <div style={{ fontSize: 10, marginTop: 4, opacity: 0.6 }}>
                    {new Date(review.createdAt).toLocaleDateString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MerchantReviews;
